import { FeatureFlagsState } from '@/types/FeatureFlags/FeatureFlagsState';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: FeatureFlagsState = {
  oneMedicalMonthlyYearlyDeductible: false,
};

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setOneMedicalMonthlyYearlyDeductible: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.oneMedicalMonthlyYearlyDeductible = action.payload;
    },
  },
});

export const { setOneMedicalMonthlyYearlyDeductible } =
  featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
